// columns/SourceValueColumn.tsx
import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip, Typography } from "@mui/material";
import { Label } from "../../../model/Label";
import CopyToClipBoard from "../../../components/ui/CopyToClipBoard";

const SourceValueCellRenderer = (params: GridRenderCellParams<Label>) => {
  const value = params.row.sourceValue || "";

  return (
    <div className="flex items-center justify-between h-full w-full relative">
      <Tooltip title={params.row.id != null ? `ID: ${params.row.id}` : ""}>
        <div className="source-value-container p-1.5 bg-gray-50 rounded-md border border-gray-200 w-full h-full overflow-y-auto whitespace-pre-wrap break-words leading-relaxed">
          {value}
        </div>
      </Tooltip>
      <div className="absolute bottom-[4px] right-2 flex items-center space-x-2 z-2 text-primary-dark">
        <CopyToClipBoard value={value} />
      </div>
    </div>
  );
};

const SourceValueHeaderRenderer = () => (
  <div className="flex items-center gap-1">
    <Typography variant="subtitle2" fontWeight="medium">
      Source Value
    </Typography>
    <div className="px-1.5 py-0.5 bg-blue-100 text-primary-dark rounded text-xs font-medium">FR</div>
  </div>
);

export const sourceValueColumn: GridColDef = {
  field: "sourceValue",
  headerName: "Source Value",
  flex: 1,
  width: 150,
  minWidth: 150,
  hideable: false,
  headerClassName: "labels-table--header",
  renderHeader: SourceValueHeaderRenderer,
  renderCell: SourceValueCellRenderer,
};
